import { Helmet } from "react-helmet-async";

const SITE = "https://www.thenexora.co.in";
const IMAGE = `${SITE}/orginal.png`;

export default function SEO({
  title,
  description,
  keywords,
  path = "",
}) {
  const url = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index,follow" />
      <meta name="author" content="Nexora Machinery" />

      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Nexora Machinery" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={IMAGE} />
    </Helmet>
  );
}